export const isRequired = param => {
  throw new Error(`${param} is Required`);
};
